var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"loading":_vm.loading}},[(!_vm.loading)?[_c('d-header',{class:{
        'pt-5': _vm.$laravel.user.is_owner_contact || _vm.$laravel.user.owner_id,
      },attrs:{"actions":[
        {
          label: _vm.$t('save'),
          primary: true,
          color: 'is-primary',
          action: _vm.submitForm,
        },
      ],"fluid":"","breadcrumbs":false}},[_c('h2',{staticClass:"title is-4"},[_c('d-previous-btn',{attrs:{"path":'/owners/' + _vm.model.owner_id + '/owner-businesses'}}),_vm._v("\n        "+_vm._s(_vm.model.name)+"\n      ")],1)]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"action":"edit","model":_vm.model,"owner_id":_vm.model.owner_id}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }